import { useState } from 'react';
import useFormValidation from '../../../hooks/useFormValidation';
import useSuspendAvisoObraFieldsConfig from './useSuspendAvisoObraFieldsConfig';
import { useTranslation } from 'react-i18next';

export interface SuspendAvisoObraFormData {
    suspensionDate: string;
    motive: string;
}

export const INITIAL_VALUES: SuspendAvisoObraFormData = {
    suspensionDate: '',
    motive: ''
};

export const useSuspendAvisoObraForm = (selectedObra: any) => {
    const [formData, setFormData] = useState<SuspendAvisoObraFormData>(INITIAL_VALUES);

    const { t } = useTranslation('avisoObra');

    const { errors, hasValidationErrors, validateForm, handleBlurValidation, setErrors } =
        useFormValidation();

    const { fieldsConfig } = useSuspendAvisoObraFieldsConfig({
        t,
        formData,
        handleBlurValidation,
        selectedObra
    });

    const handleChange = (name: string, value: any) => {
        setErrors((prevState) => ({
            ...prevState,
            [name]: { hasError: false, errorMessage: '' }
        }));
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const resetForm = () => {
        setFormData(INITIAL_VALUES);
        setErrors({});
    };

    return {
        formData,
        errors,
        hasValidationErrors,
        fieldsConfig,
        handleChange,
        validateForm,
        resetForm
    };
};

export default useSuspendAvisoObraForm;
